import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { RecruitmentProvider } from './context/RecruitmentContext';
import { ServicesProvider } from './context/ServicesContext';
import { MetiersProvider } from './context/MetiersContext';
import { SocieteProvider } from './context/SocieteContext';
import { ReferencesProvider } from './context/ReferencesContext';
import { UsersProvider } from './context/UsersContext';
import { HeroSlidesProvider } from './context/HeroSlidesContext';
import { EffectsProvider } from './context/EffectsContext';
import { MessagesProvider } from './context/MessagesContext';
import { TechnologiesProvider } from './context/TechnologiesContext';
import { HighlightsProvider } from './context/HighlightsContext';
import { HomeProvider } from './context/HomeContext';
import { ContactProvider } from './context/ContactContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <RecruitmentProvider>
            <ServicesProvider>
              <MetiersProvider>
                <SocieteProvider>
                  <ReferencesProvider>
                    <UsersProvider>
                      <HeroSlidesProvider>
                        <EffectsProvider>
                          <MessagesProvider>
                            <TechnologiesProvider>
                              <HighlightsProvider>
                                <HomeProvider>
                                  <ContactProvider>
                                    <SiteSettingsProvider>
                                      <App />
                                    </SiteSettingsProvider>
                                  </ContactProvider>
                                </HomeProvider>
                              </HighlightsProvider>
                            </TechnologiesProvider>
                          </MessagesProvider>
                        </EffectsProvider>
                      </HeroSlidesProvider>
                    </UsersProvider>
                  </ReferencesProvider>
                </SocieteProvider>
              </MetiersProvider>
            </ServicesProvider>
          </RecruitmentProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
